/**
 * The angularjs states related to the module MassMessagingModule.
 */
massMessagingStates.$inject = ['$stateProvider'];
export function massMessagingStates($stateProvider) {

  $stateProvider
    .state('auth.alcmeon.fuse.mass-messaging', {
      url: '/mass-messaging?{status:int}',
      data: {
        isMarketingMode: true
      },
      resolve: {
        campaignScenarios: ['$stateParams', 'MetricsFactory', function ($stateParams, MetricsFactory) {
          return MetricsFactory.getScenarios($stateParams.companyId, 'campaign-scenarios')
            .then(response => response.data);
        }],
        segments: ['$stateParams', 'SegmentsFactory', function ($stateParams, SegmentsFactory) {
          return SegmentsFactory.getSegments($stateParams.companyId).then(response => response.data.segments);
        }]
      },
      views: {
        'container@auth': {
          template: '<angular-mass-messaging [segments]="segments" [campaign-scenarios]="campaignScenarios"></angular-mass-messaging>',
          controller: ['$scope', 'campaignScenarios', 'segments', function ($scope, campaignScenarios, segments) {
            $scope.campaignScenarios = campaignScenarios;
            $scope.segments = segments;
          }]
        }
      }
    })
    .state('auth.alcmeon.fuse.mass-messaging.details', {
      url: '/details/{id:int}',
      data: {
        isMarketingMode: true
      },
      resolve: {
        campaign: ['$stateParams', 'AngularMassMessagingService', 'loggedUser', function ($stateParams, AngularMassMessagingService) {
          return AngularMassMessagingService.getCampaign($stateParams.id).toPromise();
        }],
      },
      views: {
        'container@auth': {
          template: '<angular-mass-messaging-details [campaign]="campaign"></angular-mass-messaging-details>',
          controller: ['$scope', 'campaign', function ($scope, campaign) {
            $scope.campaign = campaign;
          }]
        }
      }
    })
    ;
}
